import { render, staticRenderFns } from "./IngredientItemAssociation.vue?vue&type=template&id=09e007f9&"
import script from "./IngredientItemAssociation.vue?vue&type=script&lang=js&"
export * from "./IngredientItemAssociation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports